import axios from 'axios';
import { store } from './redux/store/store';
import actions from './redux/auth/action';

let isLoggingOut = false;

const BASIC_AUTH_USERNAME = 'voiceoc_aster_@pp_voiceoc';
const BASIC_AUTH_PASSWORD = 'voiceoc_aster_@pp_voiceoc@2021';

const hasActiveSession = () => {
  const jwtToken = localStorage.getItem('jwtToken');
  return (
    typeof jwtToken === 'string' &&
    jwtToken !== '' &&
    jwtToken !== 'null'
  );
};

const getResponseMessage = (data) => {
  if (typeof data === 'string') {
    return data;
  }
  if (data && typeof data.message === 'string') {
    return data.message;
  }
  return '';
};

const isSessionExpiredResponse = (error) => {
  if (!error || !error.response || !hasActiveSession()) {
    return false;
  }

  const { status, data } = error.response;
  const message = getResponseMessage(data);

  if (data && data.statusCode === 201) {
    return true;
  }

  if (message === 'Invalid Session or Session expired') {
    return true;
  }

  if (
    status === 500 &&
    message === 'Token expired please login again.'
  ) {
    return true;
  }

  return false;
};

export const handleSessionExpired = () => {
  if (isLoggingOut || !hasActiveSession()) {
    return;
  }

  isLoggingOut = true;
  store.dispatch(actions.authLogout());

  const loginPath = '/login';
  if (window.location.pathname !== loginPath) {
    window.location.replace(loginPath);
  } else {
    isLoggingOut = false;
  }
};

const handleAuthError = (error) => {
  if (isSessionExpiredResponse(error)) {
    handleSessionExpired();
  }
  return Promise.reject(error);
};

const axiosApiInstance = axios.create();
export const axiosBasicAuth = axios.create();

axiosApiInstance.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axiosApiInstance.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem('jwtToken');
    if (jwtToken) {
      config.headers.common['Authorization'] = `Bearer ${jwtToken}`;
    } else {
      const basicAuth = 'Basic ' + btoa(`${BASIC_AUTH_USERNAME}:${BASIC_AUTH_PASSWORD}`);
      config.headers.common['Authorization'] = ` ${basicAuth}`;
    }
    return config;
  },
  handleAuthError
);

axiosApiInstance.interceptors.response.use(
  (res) => res,
  handleAuthError
);

axiosBasicAuth.interceptors.request.use(
  (config) => {
    const basicAuth = 'Basic ' + btoa(`${BASIC_AUTH_USERNAME}:${BASIC_AUTH_PASSWORD}`);
    config.headers.common['Authorization'] = ` ${basicAuth}`;
    return config;
  },
  handleAuthError
);

axiosBasicAuth.interceptors.response.use(
  (res) => res,
  handleAuthError
);

export default axiosApiInstance;
